import FixedDepositsCarousel from './Carousel';
import FixedDepositsBenefits from './Benefits';
import FDReturnsCalculator from './Calculator';
import FixedDepositsHero from './HeroSection';
import FDBookingSteps from './BookingSteps';
import FDInterestRateComparison from './ComparisonTable';
import FDFaqs from './FDFaqs';

export {
    FixedDepositsCarousel,
    FixedDepositsBenefits,
    FDReturnsCalculator,
    FixedDepositsHero,
    FDBookingSteps,
    FDInterestRateComparison,
    FDFaqs,
};
